import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls"];
import * as React from "react";
import { ConfigContext } from "../../ConfigProvider";
import { RadioOptionTypeContextProvider } from "./context";
import Radio from "./radio";
import { jsx as _jsx } from "react/jsx-runtime";
var RadioButton = function RadioButton(props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var customizePrefixCls = props.prefixCls,
    radioProps = _objectWithoutProperties(props, _excluded);
  var prefixCls = getPrefixCls("radio", customizePrefixCls);
  return /*#__PURE__*/_jsx(RadioOptionTypeContextProvider, {
    value: "button",
    children: /*#__PURE__*/_jsx(Radio, _objectSpread(_objectSpread({
      prefixCls: prefixCls
    }, radioProps), {}, {
      type: "radio",
      ref: ref
    }))
  });
};
export default /*#__PURE__*/React.forwardRef(RadioButton);